const ACTORS = {
  STUDENT: 'student',
  CC: 'lead_coach',
  HC: 'head_coach',
  ADMIN: 'admin',
  PARENT: 'parent',
  FC: 'fa_coach',
};

export default [
  {
    Meetings: [
      {
        value: 'COACHING_SCHEDULED',
        label: 'Coaching Session scheduled/canceled/no show/completed',
        actors: [ACTORS.ADMIN, ACTORS.CC, ACTORS.PARENT, ACTORS.STUDENT],
      },
      {
        value: 'COACHING_CANCELLED',
        label: 'Coaching Session scheduled/canceled/no show/completed',
        actors: [ACTORS.ADMIN, ACTORS.CC, ACTORS.PARENT, ACTORS.STUDENT],
      },
      {
        value: 'COACHING_NOSHOW',
        label: 'Coaching Session scheduled/canceled/no show/completed',
        actors: [ACTORS.ADMIN, ACTORS.CC, ACTORS.PARENT, ACTORS.STUDENT],
      },
      {
        value: 'COACHING_DONE',
        label: 'Coaching Session scheduled/canceled/no show/completed',
        actors: [ACTORS.ADMIN, ACTORS.CC, ACTORS.PARENT, ACTORS.STUDENT],
      },
      {
        value: 'MILESTONE_MEETING_SCHEDULED',
        label: 'Milestone meeting scheduled/canceled/no show/completed',
        actors: [
          ACTORS.ADMIN,
          ACTORS.CC,
          ACTORS.HC,
          ACTORS.PARENT,
          ACTORS.STUDENT,
        ],
      },
      {
        value: 'MILESTONE_MEETING_CANCELLED',
        label: 'Milestone meeting scheduled/canceled/no show/completed',
        actors: [
          ACTORS.ADMIN,
          ACTORS.CC,
          ACTORS.HC,
          ACTORS.PARENT,
          ACTORS.STUDENT,
        ],
      },
      {
        value: 'MEETING_NOSHOW',
        label: 'Milestone meeting scheduled/canceled/no show/completed',
        actors: [
          ACTORS.ADMIN,
          ACTORS.CC,
          ACTORS.HC,
          ACTORS.PARENT,
          ACTORS.STUDENT,
        ],
      },
      {
        value: 'MILESTONE_MEETING_DONE',
        label: 'Milestone meeting scheduled/canceled/no show/completed',
        actors: [
          ACTORS.ADMIN,
          ACTORS.CC,
          ACTORS.HC,
          ACTORS.PARENT,
          ACTORS.STUDENT,
        ],
      },
      {
        value: 'FA_MEETING_SCHEDULED',
        label: 'Financial Aid Meeting scheduled/canceled/no show/completed',
        actors: [ACTORS.ADMIN, ACTORS.PARENT],
      },
      {
        value: 'FA_MEETING_CANCELLED',
        label: 'Financial Aid Meeting scheduled/canceled/no show/completed',
        actors: [ACTORS.ADMIN, ACTORS.PARENT],
      },
      {
        value: 'FA_MEETING_NOSHOW',
        label: 'Financial Aid Meeting scheduled/canceled/no show/completed',
        actors: [ACTORS.ADMIN, ACTORS.PARENT],
      },
      {
        value: 'FA_MEETING_DONE',
        label: 'Financial Aid Meeting scheduled/canceled/no show/completed',
        actors: [ACTORS.ADMIN, ACTORS.PARENT],
      },
      {
        value: 'HC_MEETING_REMINDER',
        label: 'Milestone Meeting Reminder',
        actors: [
          ACTORS.ADMIN,
          ACTORS.CC,
          ACTORS.HC,
          ACTORS.PARENT,
          ACTORS.STUDENT,
        ],
      },
      {
        value: 'CC_MEETING_REMINDER',
        label: 'Coaching Session Reminder',
        actors: [ACTORS.ADMIN, ACTORS.CC, ACTORS.PARENT, ACTORS.STUDENT],
      },
      {
        value: 'FA_MEETING_REMINDER',
        label: 'Financial Aid Meeting Reminder',
        actors: [ACTORS.ADMIN, ACTORS.PARENT],
      }
    ],
    name: 'Meetings',
    exclude: [],
  },
  {
    Timeline: [
      {
        value: 'EXERCISE_SUBMITTED',
        label: 'Exercise Submitted',
        actors: [ACTORS.ADMIN, ACTORS.CC],
      },
      {
        value: 'MILESTONE_DONE',
        label: 'Milestone Completed',
        actors: [ACTORS.ADMIN, ACTORS.CC, ACTORS.HC, ACTORS.PARENT],
      },
    ],
    name: 'Timeline',
    exclude: [ACTORS.STUDENT],
  },
  {
    Essays: [
      {
        value: 'ESSAY_UNIVERSITY_ADD',
        label: 'Supplemental essay card created for a university',
        actors: [ACTORS.ADMIN],
      },
      {
        value: 'ESSAY_CREATE',
        label: 'Supplemental essay prompt added for a university',
        actors: [ACTORS.ADMIN],
      },
      {
        value: 'STUDENT_ESSAY_STATUS_CHANGED_DRAFT',
        label: 'Supplemental Essay status Changed',
        actors: [
          ACTORS.ADMIN,
          ACTORS.CC,
          ACTORS.HC,
          ACTORS.PARENT,
          ACTORS.STUDENT,
        ],
      },
      {
        value: 'OTHER_ESSAY_STATUS_CHANGED_DRAFT',
        label: 'Supplemental Essay status Changed',
        actors: [
          ACTORS.ADMIN,
          ACTORS.CC,
          ACTORS.HC,
          ACTORS.PARENT,
          ACTORS.STUDENT,
        ],
      },
      {
        value: 'OTHER_ESSAY_STATUS_CHANGED_DRAFT_WITH_DUE_DATE',
        label: 'Supplemental Essay status Changed',
        actors: [ACTORS.ADMIN, ACTORS.PARENT, ACTORS.STUDENT],
      },
      {
        value: 'ESSAY_STATUS_UPDATE_CC_REVIEW',
        label: 'Supplemental Essay status Changed',
        actors: [ACTORS.ADMIN, ACTORS.CC, ACTORS.PARENT, ACTORS.STUDENT],
      },
      {
        value: 'ESSAY_STATUS_UPDATE_HC_REVIEW',
        label: 'Supplemental Essay status Changed',
        actors: [
          ACTORS.ADMIN,
          ACTORS.CC,
          ACTORS.HC,
          ACTORS.PARENT,
          ACTORS.STUDENT,
        ],
      },
      {
        value: 'ESSAY_STATUS_UPDATED_DONE',
        label: 'Supplemental Essay status Changed',
        actors: [
          ACTORS.ADMIN,
          ACTORS.CC,
          ACTORS.HC,
          ACTORS.PARENT,
          ACTORS.STUDENT,
        ],
      },
      {
        value: 'PERSONAL_STATEMENT_ADDED',
        label: 'Personal Statement Started',
        actors: [ACTORS.ADMIN],
      },
      {
        value: 'STUDENT_PERSONAL_STATEMENT_STATUS_CHANGED_DRAFT',
        label: 'Personal Statement status Changed',
        actors: [
          ACTORS.ADMIN,
          ACTORS.CC,
          ACTORS.HC,
          ACTORS.PARENT,
          ACTORS.STUDENT,
        ],
      },
      {
        value: 'OTHER_PERSONAL_STATEMENT_STATUS_CHANGED_DRAFT',
        label: 'Personal Statement status Changed',
        actors: [
          ACTORS.ADMIN,
          ACTORS.CC,
          ACTORS.HC,
          ACTORS.PARENT,
          ACTORS.STUDENT,
        ],
      },
      {
        value: 'OTHER_PERSONAL_STATEMENT_STATUS_CHANGED_DRAFT_WITH_DUE_DATE',
        label: 'Personal Statement status Changed',
        actors: [ACTORS.ADMIN],
      },
      {
        value: 'PERSONAL_STATEMENT_STATUS_CHANGED_CC_REVIEW',
        label: 'Personal Statement status Changed',
        actors: [ACTORS.ADMIN, ACTORS.CC, ACTORS.PARENT, ACTORS.STUDENT],
      },
      {
        value: 'PERSONAL_STATEMENT_STATUS_CHANGED_HC_REVIEW',
        label: 'Personal Statement status Changed',
        actors: [
          ACTORS.ADMIN,
          ACTORS.CC,
          ACTORS.HC,
          ACTORS.PARENT,
          ACTORS.STUDENT,
        ],
      },
      {
        value: 'PERSONAL_STATEMENT_STATUS_CHANGED_DONE',
        label: 'Personal Statement status Changed',
        actors: [
          ACTORS.ADMIN,
          ACTORS.CC,
          ACTORS.HC,
          ACTORS.PARENT,
          ACTORS.STUDENT,
        ],
      },
    ],
    name: 'Essays',
    exclude: [],
  },
  {
    'School list': [
      {
        value: 'SCHOOL_STATUS_UPDATE',
        label: 'College status changed',
        actors: [ACTORS.ADMIN, ACTORS.CC, ACTORS.HC, ACTORS.PARENT],
      },
    ],
    'name': 'School list',
    'exclude': [ACTORS.STUDENT],
  },
  {
    Communication: [
      // { value: 'EMAIL_SENT', label: 'All email notifications' },
      {
        value: 'SMS_SENT',
        label: 'Notifications for text message',
        actors: [
          ACTORS.ADMIN,
          ACTORS.CC,
          ACTORS.HC,
          ACTORS.PARENT,
          ACTORS.STUDENT,
        ],
      },
      {
        value: 'CHAT_UNREAD_REMINDER',
        label: 'Unread chat message reminder',
        actors: [
            ACTORS.STUDENT,
            ACTORS.PARENT
        ]
      },
      // { value: 'CHAT_MESSAGE_SENT', label: 'All chat message notifications' },
    ],
    name: 'Communication',
    exclude: [],
  },
  {
    General: [
      {
        value: 'STUDENT_INACTIVE',
        label: 'Student inactive on WeAdmit platform for 2 weeks',
        actors: [ACTORS.ADMIN, ACTORS.PARENT, ACTORS.STUDENT],
      },

      {
        value: 'STUDENT_PROFILE_COMPLETED',
        label: 'Student onboarding quiz completed',
        actors: [ACTORS.ADMIN],
      },
      {
        value: 'STUDENT_PROFILE_INCOMPLETE',
        label: 'Student onboarding quiz incomplete',
        actors: [ACTORS.ADMIN, ACTORS.PARENT, ACTORS.STUDENT],
      },
    ],
    name: 'General',
    exclude: [ACTORS.CC, ACTORS.HC],
  },
];
